__webpack_require__.p = "/memory_card/";